// require('./contact')

$(document).ready(function () {
  var items = $("#rightSidebarServices").find(".content-details");
  var firstItem = $(items[0]);
  var lastItem = $(items[items.length - 1]);

  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
  var offset = 131;
  items.each(function () {
    var el = $(this);
    var id = el.attr("id");
    $("#" + id)
      .find("h2")
      .waypoint(
        function (direction) {
          if (direction === "down") {
            $(".active").removeClass("active");
            $("." + id).addClass("active");
            console.log("Scrolled down to waypoint " + id);
          }
        },
        {
          offset: "45%",
        }
      );
    $("#" + id)
      .find("h2")
      .waypoint(
        function (direction) {
          if (direction !== "down") {
            $(".active").removeClass("active");
            $("." + id).addClass("active");
            console.log("Scrolled up to waypoint " + id);
          }
        },
        {
          offset: offset - 30,
        }
      );
  });

  function stick_index() {
    var scrollTop = $(window).scrollTop(),
      elementOffsetA = firstItem.offset().top,
      elementOffsetB = lastItem.offset().top - 30,
      distanceA = elementOffsetA - scrollTop,
      distanceB = elementOffsetB - scrollTop;
    var x = $(".index");
    if (distanceA <= 1 && distanceB >= 1) {
      x.addClass("stick");
    } else if (distanceA > 1) {
      x.removeClass("stick");
      x.css("top", "");
    } else if (distanceB < 1) {
      x.removeClass("stick");
      x.css("top", elementOffsetB);
    }
  }

  window.onscroll = stick_index;
});



// WEBPACK FOOTER //
// ./scripts/libraries/services.js